export const CROPPED_IMAGE_PREFIX = 'sidedoorcrop-';
